import {defineStore} from 'pinia';
import {BaseStore} from '@/stores/baseStore';
import {ModuleNotification} from '../moduleConst';
import api from '@/apis/other/notificationApi';
import {MSConstant} from '@/commons/wildcards/index.js';
import NotificationType from '@/commons/wildcards/constants/NotificationType.js';
import NotificationDetailType from '@/commons/wildcards/constants/NotificationDetailType.js';
import i18nBaseForm from '@/i18ns/vi/i18nBaseForm';
import {useContextStore} from '../contextStore';
import commonFn from '@/commons/commonFunction';
import moment from 'moment'; // Hoặc import { format, parseISO } from 'date-fns';

/**
 * Store thông báo
 * ndhieu3 25.09.2023
 */
const notificationStore = new BaseStore(api);
export const useNotificationStore = defineStore(ModuleNotification, {
  state: () => ({
    ...notificationStore.state,
    _config: {key: 'notification_id', name: 'data', table: 'notification', moduleName: 'Thông báo'},
    moduleName: 'notification',
    unread: 0,
    isBellRing: false,
  }),
  actions: {
    ...notificationStore.action,
    /**
     * Lấy dữ liệu thông báo mới nhất
     * ndhieu3 25.09.2023
     */
    async getNewestNoti() {
      let res = null;
      try {
        res = await api.getNewestNoti();
        return res;
      } catch (err) {
        console.log(err);
      }
    },

    /**
     * Lấy dữ liệu thông báo
     * @param {*} context
     * @param {*} payload
     * @returns
     */
    async getData(payload) {
      const param = genPayloadGetNoti(payload, false);
      let data = await api.getNoti(param || {});
      let res = data?.Data || [];

      customNotification(res);

      return {
        res: res,
        data: data,
      };
    },

    /**
     * Cập nhật đã đọc
     * @param {*} context
     * @param {*} id
     * @returns
     */
    async updateRead(item) {
      let res = null;
      let id = item.notification_id;

      try {
        res = await api.updateRead(id);
      } catch (error) {}
    },

    /**
     * Lấy thông báo chưa đọc
     * @param {*} context
     * @param {*} payload
     * @returns
     */
    async unreadNotification(payload, ringBell) {
      let res = null;

      payload = payload || {
        user_id: useContextStore().CurUserId,
        noticeType: MSConstant.NoticeType.None,
        readed: false,
        skip: 0,
        take: 0,
      };
      const param = genPayloadGetNoti(payload, true);

      try {
        let data = await api.getUnread(param || {});
        res = data?.Unread || 0;

        // Cập nhật số lượng thông báo chưa đọc
        this.unread = res;

        // Có rung chuông thông báo hay ko
        this.isBellRing = ringBell && res > 0;
      } catch (error) {}

      return res;
    },
  },
  getters: {
    ...notificationStore.getters,
  },
});

/**
 * Lấy tham số để gọi lấy dữ liệu ds thông báo
 * @param {*} payload
 * @param {*} isGetNumber
 * @returns
 */
function genPayloadGetNoti(payload, isGetNumber) {
  payload = payload || {};
  return {
    in_notify_type: getFilterPayload(payload),
    user_id: payload.user_id,
    status: payload.readed == null ? -1 : payload.readed ? 1 : 0,
    skip: payload.skip,
    take: payload.take,
    get_number: isGetNumber,
  };
}

/**
 * Lọc thông báo theo loại
 * @returns
 */
function getFilterPayload(payload) {
  var def = [];

  switch (payload?.noticeType || MSConstant.NoticeType.None) {
    case MSConstant.NoticeType.Action:
      def = [
        MSConstant.NotificationType.PostBath,
        MSConstant.NotificationType.ChangeDatabaseName,
        MSConstant.NotificationType.DeletingDatabase,
        MSConstant.NotificationType.EndDeleteDatabase,
        MSConstant.NotificationType.CreatingData,
        MSConstant.NotificationType.EndCreateData,
        MSConstant.NotificationType.System,
        MSConstant.NotificationType.BackupDataCompleted,
        MSConstant.NotificationType.RestoreDataCompleted,
        MSConstant.NotificationType.Sharing,
        MSConstant.NotificationType.Unsharing,
        MSConstant.NotificationType.CopyData,
        MSConstant.NotificationType.ReBuild,
        MSConstant.NotificationType.ConvertSuccess,
      ];
      break;
    case MSConstant.NoticeType.Promotion:
      def = [
        /** Khuyến mại */
        MSConstant.NotificationType.Promotion,
      ];
      break;
    case MSConstant.NoticeType.None:
    default:
      def = [
        MSConstant.NotificationType.PostBath,
        MSConstant.NotificationType.Promotion,
        MSConstant.NotificationType.ChangeDatabaseName,
        MSConstant.NotificationType.DeletingDatabase,
        MSConstant.NotificationType.EndDeleteDatabase,
        MSConstant.NotificationType.CreatingData,
        MSConstant.NotificationType.EndCreateData,
        MSConstant.NotificationType.System,
        MSConstant.NotificationType.BackupDataCompleted,
        MSConstant.NotificationType.RestoreDataCompleted,
        MSConstant.NotificationType.Sharing,
        MSConstant.NotificationType.Unsharing,
        MSConstant.NotificationType.CopyData,
        MSConstant.NotificationType.ReBuild,
        MSConstant.NotificationType.ConvertSuccess,
      ];
      break;
  }

  return def.join(';');
}

/**
 * Custom thông báo
 * modified by: ntloc 2.12.2022
 */
function customNotification(arr) {
  var contextStore = useContextStore();
  arr.forEach(item => {
    if (item.data) {
      item.targetData = JSON.parse(item.data);
      var clickError = 'Bấm vào đây để';
      switch (item.type) {
        // Đổi tên dữ liệu
        case NotificationType.ChangeDatabaseName:
          item.text = `<b>Đã hoàn thành</b> đổi tên dữ liệu <b>${commonFn.processXssValue(
            item.targetData.old_database_name,
          )}</b> thành <b>${commonFn.processXssValue(item.targetData.database_name)}</b>.`;
          break;
        // Đang xóa dữ liệu
        case NotificationType.DeletingDatabase:
          item.text = `<b>Đang thực hiện</b> xóa dữ liệu. Vui lòng chờ trong giây lát.`;
          break;
        // Xóa dữ liệu thành công
        case NotificationType.EndDeleteDatabase:
          item.text = `<b>Đã hoàn thành</b> xóa dữ liệu <b>${commonFn.processXssValue(
            item.targetData.database_name,
          )}</b>.`;
          break;
        /** Ghi sổ bỏ ghi theo lô */
        case NotificationType.PostBath:
          var {status, type} = item.targetData;
          type = commonFn.processXssValue(
            type == NotificationDetailType.PostBath.Type.UnPost ? 'bỏ ghi sổ theo lô' : 'ghi sổ theo lô',
          );
          var txt =
            status == NotificationDetailType.PostBath.Status.Start
              ? `<b>Đang thực hiện</b> ${type}. Vui lòng chờ trong giây lát.`
              : `<b>Đã hoàn thành</b> ${type}.`;

          if (status == NotificationDetailType.PostBath.Status.Complete && item.targetData.number_error) {
            txt += ' ' + i18nBaseForm.Notification.ErrorMes.format(type);
          }

          item.text = txt;
          break;
        case NotificationType.CreatingData:
          item.text = `<b>Đang thực hiện</b> thêm mới dữ liệu. Vui lòng chờ trong giây lát.`;
          break;
        case NotificationType.EndCreateData:
          item.text = `<b>Đã hoàn thành</b> thêm mới dữ liệu <b>${commonFn.processXssValue(
            item.targetData.database_name,
          )}</b>.`;
          break;
        case NotificationType.ErrorCreateData:
          item.text =
            i18nBaseForm.Notification.ErrorCreateData +
            `<b>${commonFn.processXssValue(item.targetData.database_name)}</b>`;
          break;
        case NotificationType.System:
        case NotificationType.Promotion:
          item.title = item.targetData.title;
          item.text = item.targetData.content;
          item.link = item.targetData.button_name ? '' : item.targetData.button_link;

          break;
        case NotificationType.BackupDataCompleted:
          if (item.targetData.status == MSConstant.BackupDataStatus.BackupSuccessful) {
            item.text = `<b class="color-green">Đã hoàn thành</b> sao lưu <b>${commonFn.processXssValue(
              item.targetData.backup_name,
            )}</b>`;
          } else if (item.targetData.status == MSConstant.BackupDataStatus.BackupFailed) {
            item.text = `Sao lưu <b>${commonFn.processXssValue(
              item.targetData.backup_name,
            )}</b> không thành công. Vui lòng liên hệ MISA để được hỗ trợ.`;
          }
          break;
        case NotificationType.RestoreDataCompleted:
          if (item.targetData.status == MSConstant.RestoreDataStatus.RestoreSuccess) {
            item.text = `<b class="color-green">Đã hoàn thành</b> phục hồi <b>${commonFn.processXssValue(
              item.targetData.restore_name,
            )}</b>. `;
            item.link1 = {
              text: 'Mở dữ liệu',
              code: 'ChangeDatabaseUse',
              data: item.targetData,
            };
          } else if (item.targetData.status == MSConstant.RestoreDataStatus.RestoreError) {
            item.text = `Khôi phục dữ liệu <b>${commonFn.processXssValue(
              item.targetData.restore_name,
            )}</b> không thành công. Vui lòng liên hệ MISA để được hỗ trợ`;
          }
          break;
        case NotificationType.Sharing:
        case NotificationType.Unsharing:
          item.text = `<b>${item.targetData.fromTenant ?? ''}</b> ${item.targetData.content ?? ''}`;
          break;
        /**
         * Sao chép dữ liệu
         */
        case NotificationType.CopyData:
          var databaseName = item.targetData.database_name;
          var curTenantName = contextStore.CurDatabaseName;
          if (item.targetData.tenant_id != contextStore.CurTenantId) {
            databaseName = `${databaseName} - ${item.targetData.tenant_name}`;
            curTenantName = `${contextStore.CurDatabaseName} - ${contextStore.CurTenantName}`;
          }
          item.text = `Hoàn thành sao chép dữ liệu từ <b>${databaseName}</b> đến dữ liệu <b>${curTenantName}</b>`;
          break;
        case NotificationType.ReBuild:
          if (item?.data) {
            let data = JSON.parse(item?.data);
            const fromDate = moment(data?.from_date).format('DD/MM/YYYY'); // Sử dụng moment.js
            const toDate = moment(data?.to_date).format('DD/MM/YYYY'); // Sử dụng moment.js
            item.text = `<b class="color-green">Đã hoàn thành</b> bảo trì dữ liệu từ ngày <b>${fromDate}</b> đến ngày <b>${toDate}</b>`;
          }
          break;
        // Chuyển đổi thành công
        case NotificationType.ConvertSuccess:
          // Build text thông báo
          const desktopAppName = 'MISA Bamboo.NET 2020';
          const {online_database_name, desktop_database_name, desktop_version} = item.targetData;
          if (desktop_database_name) {
            item.text = `<b>Đã hoàn thành chuyển đổi dữ liệu</b> <b>${desktop_database_name}</b> từ <b>${desktopAppName}</b> phiên bản <b>${desktop_version}</b> lên dữ liệu <b>${online_database_name}</b>`;
          } else {
            item.text = `<b>Đã hoàn thành chuyển đổi dữ liệu</b> từ <b>${desktopAppName}</b> phiên bản <b>${desktop_version}</b> lên dữ liệu <b>${online_database_name}</b>`;
          }

          // Thêm hành động
          item.actions = [
            {
              text: 'Đối chiếu dữ liệu chuyển đổi',
            },
          ];
          break;
        default:
          break;
      }
    }
  });
}
